import styles from './Select.module.css';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<SelectOption>;
  error?: string | undefined;
  hint?: string | undefined;
  disabled?: boolean;
  name?: string;
}

export function Select({
  id,
  label,
  value,
  onChange,
  options,
  error,
  hint,
  disabled,
  name,
}: SelectProps) {
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  return (
    <div class={styles.field}>
      <label class={styles.label} for={id}>
        {label}
      </label>
      <select
        id={id}
        name={name ?? id}
        class={styles.select}
        value={value}
        disabled={disabled}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        onChange={(e) => onChange((e.currentTarget as HTMLSelectElement).value)}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value} selected={o.value === value}>
            {o.label}
          </option>
        ))}
      </select>
      {error ? (
        <span id={`${id}-error`} class={styles.error} role="alert">
          {error}
        </span>
      ) : hint ? (
        <span id={`${id}-hint`} class={styles.hint}>
          {hint}
        </span>
      ) : null}
    </div>
  );
}
